import { create } from 'zustand';
import { GameClient, GameClientState } from '../game/GameClient';
import { GameMode } from '../shared/types';

interface GameStore {
  client: GameClient | null;
  gameState: GameClientState;
  screen: 'menu' | 'lobby' | 'game' | 'editor' | 'settings' | 'shop' | 'inventory' | 'profile' | 'leaderboard' | 'social' | 'admin';
  modal: string | null;
  setClient: (client: GameClient) => void;
  updateGameState: (state: Partial<GameClientState>) => void;
  setScreen: (screen: GameStore['screen']) => void;
  setModal: (modal: string | null) => void;
  startHostGame: (name: string, mode: GameMode) => void;
  joinGame: (url: string, name: string, roomId: string) => void;
}

export const useGameStore = create<GameStore>((set, get) => ({
  client: null,
  gameState: {
    running: false,
    isHost: false,
    connected: false,
    playerId: '',
    playerName: 'Player',
    health: 100,
    armor: 0,
    alive: true,
    ammo: 30,
    reserveAmmo: 120,
    currentWeapon: 'Pulse',
    kills: 0,
    deaths: 0,
    assists: 0,
    score: 0,
    ping: 0,
    fps: 0,
    matchState: 'waiting',
    timeRemaining: 600,
    events: [],
    players: [],
    roomId: '',
  },
  screen: 'menu',
  modal: null,

  setClient: (client) => set({ client }),

  updateGameState: (partial) => set((s) => ({
    gameState: { ...s.gameState, ...partial },
  })),

  setScreen: (screen) => set({ screen }),

  setModal: (modal) => set({ modal }),

  startHostGame: (name, mode) => {
    const canvas = document.querySelector('#game-canvas') as HTMLCanvasElement;
    if (!canvas) return;

    const client = new GameClient(canvas);
    client.onStateChange((state) => {
      set({ gameState: state });
    });
    client.startAsHost(name, mode);

    set({ client, screen: 'game' });
  },

  joinGame: (url, name, roomId) => {
    const canvas = document.querySelector('#game-canvas') as HTMLCanvasElement;
    if (!canvas) return;

    const client = new GameClient(canvas);
    client.onStateChange((state) => {
      set({ gameState: state });
    });
    client.joinAsClient(url, name, roomId).then(() => {
      set({ client, screen: 'game' });
    });
  },
}));
